const platforms = [
  {
    id: 'booking',
    homeUrl: process.env.REACT_APP_BOOKING_HOME_URI,
    displayOnHomepage: false
  },
  {
    id: 'decipher',
    title: 'Decipher',
    displayOnHomepage: true,
    loginUrl: process.env.REACT_APP_DECIPHER_REDIRECT_URI,
    signupUrl: `/sign-up?client_id=decipher&confirmation_uri=/login/confirmation&hostname=${process.env.REACT_APP_DECIPHER_HOSTNAME}&redirect_uri=${encodeURIComponent(process.env.REACT_APP_DECIPHER_REDIRECT_URI)}`,
    homeUrl: '/',
    supportEmail: 'de-support@focusvision.com'
  },
  {
    id: 'revelation',
    title: 'Revelation',
    displayOnHomepage: true,
    loginUrl: '/login?client_id=revelation',
    homeUrl: 'https://researcher.studyspace.net/',
    homeUrlFn: hostname => `https://researcher.${hostname}`,
    zendeskHost: 'revelation.zendesk.com',
    supportEmail: 're-support@focusvision.com'
  },
  {
    id: 'vi',
    title: 'VideoInsights',
    displayOnHomepage: true,
    loginUrl: process.env.REACT_APP_VI_LOGIN_URI,
    homeUrl: process.env.REACT_APP_VI_HOME_URI,
    homeUrlFn: hostname => `https://${hostname}`,
    zendeskHost: 'focusvision.zendesk.com',
    supportEmail: 'vi-support@focusvision.com'
  },
  {
    id: 'vs',
    title: 'LiveVideo',
    displayOnHomepage: true,
    loginUrl: 'https://online.focusvision.com/account/',
    homeUrl: '/',
    supportEmail: 'support@focusvision.com'
  },
  {
    id: 'kinesis',
    title: 'KinesisPanel',
    displayOnHomepage: true,
    loginUrl: '',
    homeUrl: '/',
    supportEmail: 'kp-support@focusvision.com'
  },
  {
    id: 'intervu',
    title: 'InterVu',
    displayOnHomepage: true,
    loginUrl: 'https://online.focusvision.com/account/',
    homeUrl: '/',
    supportEmail: 'support@focusvision.com'
  },
  {
    id: 'new-intervu',
    homeUrl: process.env.REACT_APP_INTERVU_HOME_URI,
    displayOnHomepage: false
  }
]

export const findPlatform = platformId =>
  platforms.find(platform => platform.id === platformId)
export default platforms



// WEBPACK FOOTER //
// ./src/config/platforms.js